import BlockTypes from '../../../types/BlockTypes';
export default function isSelectionInTable(editor) {
  if (!editor.value.selection.isSet) {
    return false;
  }

  return editor.value.startBlock.type === BlockTypes.TABLE_CELL || editor.value.endBlock.type === BlockTypes.TABLE_CELL;
}